module.exports = __webpack_public_path__ + "img/couch.ac5dac23.png";